"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializePlugin = initializePlugin;
const ErrorHandler_1 = __importDefault(require("./ErrorHandler"));
function initializePlugin(envKey, appVersion) {
    if (!envKey || !appVersion) {
        console.error("Environment key and app version must be provided.");
        return;
    }
    ErrorHandler_1.default.init(envKey, appVersion);
}
